import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { CompanyRepresentativeService } from 'src/app/services/companyRepresentative.service';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-match-page',
  templateUrl: './match-page.component.html',
  styleUrls: ['./match-page.component.css']
})
export class MatchPageComponent implements OnInit {
  matchRequest
  tinToAssign
  tinMatchEmmitter: EventEmitter<boolean> = new EventEmitter();
  subscriptionMatch: any
  error
  success
  reject
  loading
  constructor(public companyRepresentativService: CompanyRepresentativeService, private router: Router, private route: ActivatedRoute, public dialog: MatDialog,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => {
      return this.companyRepresentativService.getMatchRequest(params.get('id'))
    }))
      .subscribe(mReq => {
        this.matchRequest = mReq
      }, err => { console.log(err) });
  }
  getName() {
    return localStorage.getItem('default_lang');
  }

  matchTin() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: "DIALOG.MATCH_TIN", emitter: this.tinMatchEmmitter, obj: this.matchRequest, action: "CONFIRM" }
    });
    this.subscriptionMatch = this.sharedService.confirmDialogEmitter.subscribe(async val => {
      this.loading = true
      if (val) {
        this.tinToAssign = this.tinToAssign.trim()
        let data = {tin:this.tinToAssign, id:this.matchRequest.id, lang: localStorage.getItem('default_lang')}
        let result = await this.companyRepresentativService.matchRequest(data).toPromise()
        if (!result || result.error){
          this.error = result.error
        }else{
          this.matchRequest.matched = true;
          this.matchRequest.tin = this.tinToAssign;
          this.sharedService.emitTinMatched()
          this.success = true
          this.error = null
        }
      }
      this.loading = false
    })

    dialogRef.afterClosed().subscribe(result => {
      this.subscriptionMatch.unsubscribe()
    });
  }

  denyTin(){
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: "DIALOG.DENY_TIN", emitter: this.tinMatchEmmitter, obj: this.matchRequest, action: "CONFIRM" }
    });
    this.subscriptionMatch = this.sharedService.confirmDialogEmitter.subscribe(async val => {
      this.loading = true
      if (val) {
         let data = {id:this.matchRequest.id, lang: localStorage.getItem('default_lang')}
        let result = await this.companyRepresentativService.rejectRequest(data).toPromise()
        if (!result || result.error){
          this.error = result.error
        }else{
          this.matchRequest.status = 'REJECTED'
          this.sharedService.emitTinMatched()
          this.reject = true
          this.error = null
        }
      }
      this.loading = false
    })

    dialogRef.afterClosed().subscribe(result => {
      this.subscriptionMatch.unsubscribe()
    });
  }
  getValue(val){
    if (!val) return ''
    if (typeof val === 'string')
      return val
    return val.name || ''
  }
}
